<template>
  <div>
    <header>
      <div class="header-cont display-flex ban">
        <div class="logo-div">
          <h1>
            <a href="/" title="CM">CM</a>
          </h1>
        </div>
        <div class="navbar-div display-flex m-l-100">
          <li class="navbar-li">
            <a class="navbar-a" href="#">T恤定制</a>
            <em></em>
            <ul class="dropdown">
              <!-- <li>
                <a :href="router.custom + '?ssid=1'"> <i></i>250g重磅精选款 </a>
              </li> -->
              <li>
                <a :href="router.custom + '?ssid=4'"> <i></i>40支双纱经典款 </a>
              </li>
            </ul>
          </li>
          <li class="navbar-li">
            <a class="navbar-a" href="#">探索</a>
            <em></em>
            <ul class="dropdown">
              <li>
                <a :href="router.desginer"> <i></i>设计师 </a>
              </li>
              <li>
                <a :href="router.opus"> <i></i>素材区 </a>
              </li>
            </ul>
          </li>
          <li class="navbar-li">
            <!-- <a class="navbar-a" href="#">品牌合作</a>
            <em></em>
            <ul class="dropdown">
              <li>
                <a href="/page/CLOT">
                  <i></i>CLOT
                </a>
              </li>
              <li>
                <a>
                  <i></i>爱奇艺
                </a>
              </li>
            </ul>-->
          </li>
          <li class="navbar-li">
            <!-- <a class="navbar-a" href="#">成品区</a>
            <em></em>-->
          </li>
          <li class="navbar-li">
            <!-- <a class="navbar-a" href="#">为艺术发声</a>
            <em></em>-->
          </li>
        </div>
        <div class="header-icon-div">
          <li class="header-upload">
            <a class="js-to-uploadworks" @click="toUploadWorks">
              <i class="header-upload-icon"></i>
              <span class="header-span">上传</span>
            </a>
          </li>
          <li class="header-serach">
            <a :href="router.car">
              <i class="header-serach-icon">
                <em v-show="count > 0" class="js-car-count">{{ count }}</em>
              </i>
              <span class="header-span">购物车</span>
            </a>
          </li>
          <li class="header-mess">
            <a :href="router.myMessage">
              <i class="header-mess-icon">
                <em v-show="notifyCount > 0">{{ notifyCount }}</em>
              </i>
              <span class="header-span">消息</span>
            </a>
          </li>
          <li class="header-car" v-show="isLogin">
            <a class="header-layout-icon js-layout-menu">
              <img v-show="avatar" :src="avatar" alt />
              <img v-show="!avatar" src="../../assets/img/layout.png" alt />
            </a>
            <ul class="LoginDown">
              <li>
                <a :href="router.userOpus">我的作品</a>
              </li>
              <li>
                <a :href="router.userOrder">我的订单</a>
              </li>
              <li>
                <a :href="router.userAdress">收货地址</a>
              </li>
              <li>
                <a :href="router.editUserInfo">修改资料</a>
              </li>
              <li>
                <a @click="Layout">退出登录</a>
              </li>
            </ul>
          </li>
          <li class="header-shape" v-show="!isLogin">
            <a style="display: inline-blcok">
              <i class="header-shape-icon"></i>
              <span class="header-span">
                <a class="js-login-menu" @click="jsLogin('login', true)">登录</a
                >/
                <a class="js-register-menu" @click="jsLogin('resgiter', true)"
                  >注册</a
                >
              </span>
            </a>
          </li>
          <li class="header-layout">
            <a :href="router.treaty + '?type=PROCOTOL'">
              <i class="header-menu-icon"></i>
              <span class="header-span">用户协议</span>
            </a>
          </li>
        </div>
      </div>
    </header>
    <lgoinbox
      :Login="login"
      :type="type"
      @CloseLogin="CloseLogin"
      @getinfo="getProfile"
      @LoginStatus="LoginStatus"
    ></lgoinbox>
  </div>
</template>

<script>
import $ from "jquery";
import lgoinbox from "components/lgoinbox.vue";
import router from "../../assets/js/router";
export default {
  name: "header",
  data: function () {
    return {
      isLogin: false,
      count: 0,
      notifyCount: 0,
      flag: "",
      profile: {},
      login: false,
      status: false,
      type: "login",
      avatar: "",
      router: router,
    };
  },
  components: {
    lgoinbox,
  },
  props: {},
  methods: {
    jsLogin(type, flag) {
      this.login = flag;
      this.type = type;
    },
    CloseLogin(item) {
      this.login = item;
    },
    LoginStatus(data) {
      this.status = data;
    },
    getUser: async function () {
      const res = await this.$http.get("/api/userinfo");
      if (res.data.mobile) {
        this.isLogin = true;
        this.mobile = "****" + res.data.mobile.substr(7, 4);
        this.local = res.data.local;
      }
    },
    async getProfile() {
      var uid = window.localStorage.getItem("uid");
      if (uid > 0) {
        const res = await this.$http.get("/api/designer/profile", {
          params: {
            uid: uid,
          },
        });
        this.avatar = res.data.profile.avatar;
        this.$store.commit("SET_SOURCECOUNT", res.data.sourceCount);
        this.$store.commit("SET_AMOUNT", res.data.amount);
        this.$store.commit("SET_DINGCOUNT", res.data.dingCount);
        this.$store.commit("SET_FOLLOWERCOUNT", res.data.followerCount);
        this.$store.commit("SET_PROVINCE", res.data.profile.province);
        this.$store.commit("SET_CITY", res.data.profile.city);
        this.$store.commit("SET_DISTRICT", res.data.profile.district);
        this.$store.commit("SET_BIRTHDAY", res.data.profile.birthday);
        this.$store.commit("SET_STREET", res.data.profile.street);
        this.$store.commit("SET_PROFESSION", res.data.profile.profession);
        this.$store.commit("SET_GENDER", res.data.profile.gender);
        this.$store.commit("SET_SIGN", res.data.profile.sign);
        this.$store.commit("SET_CERT", res.data.profile.cert);
        this.$store.commit("SET_BGIMG", res.data.profile.bgImg);
        this.$store.commit("SET_NICKNAME", res.data.profile.nickname);
        this.$store.commit("SET_AVATAR", res.data.profile.avatar);
        this.$store.commit("SET_DAILY", res.data.profile.daily);
        this.$store.commit("SET_GOTO", res.data.profile.goto);
        this.$store.commit("SET_HEIGHT", res.data.profile.height);
        this.$store.commit("SET_MEMOTY", res.data.profile.memory);
        this.$store.commit("SET_TOBE", res.data.profile.tobe);
        this.$store.commit("SET_WISH", res.data.profile.wish);
        this.$store.commit("SET_FOLLOWINGCOUNT", res.data.followingCount);
        sessionStorage.setItem("store", JSON.stringify(this.$store.state));
      } else {
        return;
      }
    },
    async Layout() {
      const res = await this.$http.get("/api/logout");
      if (res.code == 200) {
        this.isLogin = false;
        window.localStorage.removeItem("uid");
        window.location.href = "/";
        window.sessionStorage.removeItem("store");
      }
    },
    toUploadWorks() {
      if (window.localStorage.getItem("uid")) {
        window.location.href = router.upLoadWorks;
      } else {
        this.jsLogin("login", true);
      }
    },
    async GetcarCount() {
      if (window.localStorage.getItem("uid")) {
        const res = await this.$http.get("/api/user/count");
        this.count = res.data.shoppingCount;
        this.notifyCount = res.data.notifyCount;
      }
    },
  },
  mounted: function () {
    $(function () {
      $(".navbar-div li").hover(
        function () {
          $(this).children("em").show();
          $(this).children(".dropdown").show();
        },
        function () {
          $(this).children("em").hide();
          $(this).children(".dropdown").hide();
        }
      );

      $(".dropdown li a").hover(
        function () {
          $(this).children("i").show();
        },
        function () {
          $(this).children("i").hide();
        }
      );
    });
    this.isLogin = this.status;
    this.GetcarCount();
    this.getUser();
  },
  watch: {
    status(newValue, oldValue) {
      if (newValue) {
        this.isLogin = newValue;
      }
    },
  },
  created() {
    this.getProfile();
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      this.avatar = this.$store.state.avatar;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.ban {
  width: 1200px;
  margin: 0 auto;
}

header {
  width: 100%;
  height: 90px;
  background: rgba(255, 255, 255, 1);
  .header-cont {
    align-items: center;
    .logo-div {
      width: 52px;
      height: 41px;
      h1 {
        position: relative;
      }
      a {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
        display: -moz-box; /* 老版本语法: Firefox (buggy) */
        display: -ms-flexbox; /* 混合版本语法: IE 10 */
        display: -webkit-flex; /* 新版本语法: Chrome 21+ */
        align-items: center;
        display: inline-block;
        width: 52px;
        height: 41px;
        font-size: 0;
        overflow: hidden;
        text-indent: -999999px;
        background: url(../../assets/img/logo1.png) no-repeat;
        background-size: 52px 41px;
      }
    }
    .navbar-div {
      width: 607px;
      height: 100%;
      justify-content: space-between;
      align-items: center;
      .navbar-li {
        width: 80px;
        height: 90px;
        position: relative;
        .navbar-a {
          position: absolute;
          z-index: 9;
          display: inline-block;
          display: flex;
          width: 100%;
          height: 90px;
          font-size: 16px;
          font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 22px;
          align-items: center;
          justify-content: center;
        }
        em {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translate(0, -50%);
          display: block;
          font-style: normal;
          width: 77px;
          height: 3px;
          background: linear-gradient(
            113deg,
            rgba(231, 120, 194, 1) 0%,
            rgba(242, 159, 39, 1) 100%
          );
          display: none;
        }
        .dropdown {
          width: 200px;
          height: 103px;
          background: rgba(255, 255, 255, 1);
          position: absolute;
          top: 90px;
          left: 0;
          box-sizing: border-box;
          display: none;
          z-index: 999;
          padding: 21px 0 0 0;
          border-top: 2px solid rgba(244, 163, 64, 1);
          li {
            height: 30px;
            box-sizing: border-box;
            width: 100%;
            margin-bottom: 15px;
            display: flex;
            align-items: center;
            cursor: pointer;
            a {
              display: flex;
              align-items: center;
              padding-left: 35px;
              width: 100%;
              height: 30px;
              box-sizing: border-box;
              font-size: 16px;
              font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 28px;
              i {
                display: inline-block;
                width: 14px;
                height: 2px;
                background: linear-gradient(
                  113deg,
                  rgba(231, 120, 194, 1) 0%,
                  rgba(242, 159, 39, 1) 100%
                );
                margin-right: 4px;
                display: none;
              }
            }
          }
        }
      }
    }
    .header-icon-div {
      display: flex;
      margin-left: 90px;
      li {
        min-width: 60px;
      }
      .header-span {
        font-size: 16px;
        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
        background: linear-gradient(
          171deg,
          rgba(231, 120, 194, 1) 0%,
          rgba(242, 159, 39, 1) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        // margin-left: 5px;
        margin-right: 6px;
        display: none;
        cursor: pointer;
        a {
          cursor: pointer;
        }
      }
      .header-serach-icon {
        position: relative;
        em {
          position: absolute;
          top: -7px;
          right: -7px;
          display: block;
          padding: 0 4px;
          box-sizing: border-box;
          height: 15px;
          background: #666666;
          border-radius: 50%;
          font-size: 12px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
          text-align: center;
          font-style: normal;
        }
      }
      .header-car {
        position: relative;
        display: inline-block;
        .LoginDown {
          position: absolute;
          top: 25px;
          right: 20px;
          width: 165px;
          height: 220px;
          box-sizing: border-box;
          padding: 23px 0 0 34px;
          background: url(../../assets/img/logindown-bgc.png) no-repeat;
          background-size: 165px 220px;
          z-index: 1001;
          margin: 0;
          display: none;
          li {
            margin-bottom: 14px;
            a {
              font-size: 16px;
              font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              line-height: 22px;
              cursor: pointer;
            }
          }
          li:hover a {
            color: rgba(110, 99, 232, 1) !important;
          }
        }
      }
      .header-car:hover .LoginDown {
        display: block;
      }
      .header-upload a:hover .header-upload-icon {
        background: url(../../assets/img/upload-hover.png) no-repeat;
      }
      .header-upload a:hover span {
        display: inline-block;
      }
      .header-upload-icon {
        display: inline-block;
        width: 22px;
        height: 22px;
        background: url(../../assets/img/upload.png) no-repeat;
        background-size: 22px 22px;
        cursor: pointer;
        vertical-align: bottom;
      }
      .header-serach a:hover .header-serach-icon {
        background: url(../../assets/img/car-hover.png) no-repeat;
      }
      .header-serach a:hover span {
        display: inline-block;
      }
      .header-serach-icon {
        display: inline-block;
        width: 22px;
        height: 22px;
        background: url(../../assets/img/head-car.png) no-repeat;
        background-size: 22px 22px;
        vertical-align: bottom;
        cursor: pointer;
      }
      .header-mess a:hover .header-mess-icon {
        background: url(../../assets/img/mess-hover.png) no-repeat center bottom;
      }
      .header-mess a:hover span {
        display: inline-block;
      }
      .header-mess-icon {
        position: relative;
        display: inline-block;
        width: 22px;
        height: 22px;
        background: url(../../assets/img/mess-icon.png) no-repeat center bottom;
        background-size: 22px 17px;
        vertical-align: bottom;
        cursor: pointer;
        em {
          position: absolute;
          top: -7px;
          right: -7px;
          display: block;
          padding: 0 4px;
          box-sizing: border-box;
          height: 15px;
          background: #666666;
          border-radius: 50%;
          font-size: 12px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
          text-align: center;
          font-style: normal;
        }
      }
      .header-shape a:hover .header-shape-icon {
        background: url(../../assets/img/login-hover.png) no-repeat;
      }
      .header-shape a:hover span {
        display: inline-block;
      }
      .header-shape-icon {
        display: inline-block;
        width: 22px;
        height: 22px;
        background: url(../../assets/img/login.png) no-repeat;
        background-size: 22px 23px;
        vertical-align: bottom;
        cursor: pointer;
      }
      .header-layout a:hover .header-menu-icon {
        background: url(../../assets/img/xieyi-hover.png) no-repeat;
      }
      .header-layout a:hover span {
        display: inline-block;
      }
      .header-menu-icon {
        display: inline-block;
        width: 22px;
        height: 21px;
        background: url(../../assets/img/xieyi.png) no-repeat center top;
        background-size: 22px 21px;
        vertical-align: bottom;
        cursor: pointer;
      }
      .header-layout-icon {
        display: inline-block;
        width: 26px;
        height: 26px;
        // background: url(../../assets/img/layout.png) no-repeat center center;
        // background-size: 26px 26px;
        margin-right: 32px;
        img {
          width: 26px;
          height: 26px;
          border-radius: 50%;
        }
      }
    }
  }
}

dd {
  margin-left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue